<!-- confirm-dialog.component.html -->
<section id="popupDelete">
  <mat-dialog-content class="mat-dialog-content">
    <h3 class="example-h3 confirm-dialog__title">
      <span *ngIf="data.titleWarningIcon" class="confirm-dialog__title-icon" aria-hidden="true"></span>
      <span class="confirm-dialog__title-text">{{ data.title }}</span>
    </h3>
    <div class="mat-dialog-content">
      <p [innerHTML]="data.message"></p>
    </div>
    <div
      class="d-flex justify-content-end w-100 gap confirm-dialog__actions">

      <ng-container *ngIf="data.cancelFirst; else actionsLegacyOrder">
        <div class="btn-default">
          <button type="button" (click)="dialogRef.close(false)">{{ data.cancelButtonText || 'Cancel' }}</button>
        </div>
        <div [ngClass]="confirmWrapperClass">
          <button type="button" (click)="dialogRef.close(true)" class="confirm-button">{{ data.confirmButtonText || 'Delete' }}</button>
        </div>
      </ng-container>

      <ng-template #actionsLegacyOrder>
        <div [ngClass]="confirmWrapperClass">
          <button type="button" (click)="dialogRef.close(true)" class="confirm-button">{{ data.confirmButtonText || 'Delete' }}</button>
        </div>
        <div class="btn-default">
          <button type="button" (click)="dialogRef.close(false)">{{ data.cancelButtonText || 'Cancel' }}</button>
        </div>
      </ng-template>
    </div>
  </mat-dialog-content>
</section>
